import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { track, trackAdConversionOnce, getSignupSource } from "@/lib/analytics";

const SIGNUP_ADS_CONVERSION = "AW-18165868123/L5kHCMb7nLEcENvM1NzD";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.token) {
          localStorage.setItem("veraso_token", data.token);
        }
        setUser(data.user);
        // Fire signup conversion only on first-time Google signup, never on
        // returning logins. Backend tells us with `is_new_user`.
        if (data.is_new_user) {
          const src = getSignupSource();
          track("Register Success", {
            method: "google",
            source: src.source,
            medium: src.medium,
            campaign: src.campaign || "(none)",
            landing: src.landing_path || "(unknown)",
          });
          trackAdConversionOnce(SIGNUP_ADS_CONVERSION, data.user?.user_id, { value: 1.0, currency: "EUR" });
        }
        // Clear hash then go to dashboard
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Google auth failed:", e);
        navigate("/login?error=google", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="h-10 w-10 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Kirjataan sinua sisään...</p>
      </div>
    </div>
  );
}
